import Empty from "./empty";

// 后续可能要增加 404 403 500 网络异常 暂无权限等缺省图
export default Empty;